
import AppBrowse from "@/components/browse/SearchBrowse.vue";
import {Sale, SaleRow} from "@/models/base";
import { BookYearService } from "@/services/book-year-service";
import { BrowseService } from "@/services/browse-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import { IQueryParams } from "@/utils/query-params";
import { TranslateResult } from "vue-i18n";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";
import {SaleRowService, UserConfigService, ViewService} from "@/services";
import {BookYear} from "@/models/book-year";
import {PurchaseDocumentRowService, SaleRowServiceClass} from "@/services/sale-row-service";
import {HumanFilter} from "@/utils/human-filter";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as Sale[],
			selectedBookYear: 0,
			bookYears: BookYearService.bookYears,
			refresh: 0,
			filterOnCurrentContactEnabled: true,
			filterOnAlreadyImportedEnabled: false,
			buttonDisabled: false,
			view: null as View | null,
			generalSettings: UserConfigService.getGeneralSettings(),
		};
	},
	props: {
		contactId: {
			type: Number,
			default: 0
		},
		contactGroupId: {
			type: Number,
			required: true
		},
		disableContactFilter: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		service():SaleRowServiceClass{
			if (this.browseId == 7){
				return SaleRowService;
			}
			return PurchaseDocumentRowService;
		},
		confirmDisabled():boolean {
			if (this.selectedItems.length == 0) {
				return true;
			}
			return this.buttonDisabled;
		},
		shouldFilterOnCurrentContact():boolean {
			if (this.disableContactFilter) {
				return false;
			}
			return this.filterOnCurrentContactEnabled;
		},
		dataSource(): IBrowseBaseDataSource<SaleRow> {
			let t = this;
			let browseName = "SaleDetails";
			if (this.browseId == 17) {
				browseName = "PurchaseDocumentDetails";
			}
			let f = [] as HumanFilter[];
			if(this.contactId){
				f.push(new HumanFilter({
					Field: "this_Sale.ContactID",
					Operator: "=",
					Values: [`${this.contactId}`],
				}));
			}

			return {
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: (params:IQueryParams)=>this.service.getSalesRows(params,f,`${this.selectedBookYear}`),
				browseName,
				modelName: "SaleRow",
				getTotals(view:View):Promise<FetchedTotal[]>{
					return t.service.getTotals(view);
				}
			};
		},
		browseId():number{
			return 7;
		},
		sortedBookYearItems(): BookYear[]{
			let b = [...this.bookYears];
			return b.sort((a: BookYear, b: BookYear): number => b.Year - a.Year);
		},
		bookYearItems(): ISelectItem<number>[] {
			let result = this.sortedBookYearItems.map((b) => {
				return {
					text: b.Year + "",
					value: b.Year
				};
			});
			result.unshift({
				text: this.$ct("common.all-bookyears").toString(),
				value: 0
			});
			return result;
		},
		filterOnCurrentContactIcon():string{
			if (this.filterOnCurrentContactEnabled){
				return "users-slash";
			}
			return "users";
		},
		filterOnCurrentContactTooltip():TranslateResult{
			if (this.filterOnCurrentContactEnabled){
				return this.$ct("show-all-documents");
			}
			return this.$ct("filter-documents-on-client");
		},
		filterOnCurrentImportTooltip():TranslateResult{
			if (this.filterOnAlreadyImportedEnabled){
				return this.$ct("show-all-documents");
			}
			return this.$ct("filter-documents-on-already-imported");
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		select() {
			this.buttonDisabled = true;
			this.$emit("select", this.selectedItems);
		},
		onSelectChanged(value:Sale[]){
			this.selectedItems = value;
		},
		onBookYearChange(bookyear:number) {
			this.selectedBookYear = bookyear;
			this.refresh++;
		}
	},
	async mounted(){
		if(this.generalSettings.DefaultSaleRowsF3Browse>0){
			this.view = await ViewService.getView(this.generalSettings.DefaultSaleRowsF3Browse);
		}
	},
	components: {
		AppBrowse
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
